import { ReactNode } from 'react'

import { NavLink } from 'react-router-dom'

import { useScrollDirection } from '@/shared/hooks/useScrollDirection'

interface MobileDrawerMenuItem {
	icon: ReactNode
	label: string
	to: string
}

interface MobileDrawerMenuUIProps {
	items: MobileDrawerMenuItem[]
}

const MobileDrawerMenuUI = ({ items }: MobileDrawerMenuUIProps) => {
	const visible = useScrollDirection({
		threshold: 8,
		topThreshold: 16,
	})

	return (
		<div
			className="lg:hidden fixed bottom-0 left-0 right-0 z-40 flex h-[95px] border-t border-border player-mobile-shell transition-transform duration-300 ease-out"
			style={{
				transform: visible ? 'translateY(0)' : 'translateY(100%)',
			}}
		>
			<ul className="flex flex-row justify-between w-full px-4 py-3 items-center">
				{items.map((item, index) => (
					<li
						key={index}
						className="flex flex-col flex-1 items-center justify-center"
					>
						<NavLink
							to={item.to}
							className={({ isActive }) =>
								`flex flex-col items-center justify-center text-xs font-medium gap-2 ${
									isActive ? 'text-primary' : 'text-muted-foreground'
								}`
							}
						>
							{item.icon}
							{item.label}
						</NavLink>
					</li>
				))}
			</ul>
		</div>
	)
}

export default MobileDrawerMenuUI
